export default __webpack_public_path__ + "static/media/icon-hamburger.a56cc36e.svg";